import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { tamedDatasService } from '@/services/tameddatas';

export const fetchTamedDatas = createAsyncThunk(
    '/fetchTamedDatas',
    async (payload: { topicId: string }) => {
        const { topicId } = payload;
        if (!topicId) {
            console.warn('fetchTamedDatas called without topicId');
            return [];
        }
        const response = await tamedDatasService.fetchTamedDatas(topicId)
        return response
    }
)

const tamedDataSlice = createSlice({
    name: 'tamedData',
    initialState: {
        tamedDatas: [] as any[],
        status: 'idle',
        error: null as string | null
    },
    reducers: {
        setTamedDatas: (state, action: PayloadAction<any>) => {
            state.tamedDatas = action.payload
        },
        addTamedData: (state, action: PayloadAction<any>) => {
            state.tamedDatas.push(action.payload)
        },
        removeTamedData: (state, action: PayloadAction<any>) => {
            state.tamedDatas = state.tamedDatas.filter((tamedData: any) => tamedData.id !== action.payload)
        },
        updateTamedData: (state, action: PayloadAction<any>) => {
            // Update tamed_data by id
            if (action.payload?.id) {
                state.tamedDatas = state.tamedDatas.map((tamedData: any) =>
                    tamedData?.id === action.payload.id ? { ...tamedData, ...action.payload } : tamedData
                )
            }
        },
        updateTamedDataByDatasourceId: (state, action: PayloadAction<{ datasourceId: string; updates: any }>) => {
            // Update tamed_data entries linked to a specific datasource
            const { datasourceId, updates } = action.payload;
            console.log('🔍 updateTamedDataByDatasourceId called:', { datasourceId, updates });
            console.log('📋 Current tamedDatas:', state.tamedDatas.map((td: any) => ({
                id: td?.id,
                fk_datasources_id: td?.fk_datasources_id,
                data_type: td?.data_type,
            })));
            let matchCount = 0;
            state.tamedDatas = state.tamedDatas.map((tamedData: any) => {
                const isMatch = tamedData?.fk_datasources_id === datasourceId;
                if (isMatch) {
                    matchCount++;
                    console.log('✅ Found match:', tamedData?.id, 'updating to:', updates);
                }
                return isMatch ? { ...tamedData, ...updates } : tamedData;
            });
            console.log(`📊 Total matches updated: ${matchCount}`);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTamedDatas.pending, (state) => {
            state.status = 'loading'
        })
        builder.addCase(fetchTamedDatas.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.tamedDatas = action.payload
        })
        builder.addCase(fetchTamedDatas.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message || null
        })
    }
})

export const { setTamedDatas, addTamedData, removeTamedData, updateTamedData, updateTamedDataByDatasourceId } = tamedDataSlice.actions
export default tamedDataSlice.reducer